/* eslint-disable consistent-return */
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import blueAlertCircleIcon from '../../assets/icons/AlertCircleBlue.svg';
import alertCircleIcon from '../../assets/icons/AlertCircle.svg';
import { select } from '../../core/themev2';

const Alert = ({
  message,
  children = null,
  fontSize = '13px',
  colorScheme = 'blue',
  minHeight = '70px',
  padding = '12px 16px 12px 10px',
  margins = '0px',
  marginRightIcon = '9px',
  withoutBorder = false,
  dataPanel = 'sectionName',
  justifyContent = 'space-between',
  alignContent = 'normal'
}) => {
  return (
    <Container
      margins={margins}
      padding={padding}
      colorScheme={colorScheme}
      fontSize={fontSize}
      withoutBorder={withoutBorder}
      minHeight={minHeight}
      justifyContent={justifyContent}
      alignContent={alignContent}
      marginRightIcon={marginRightIcon}
    >
      <span />
      <p data-panel={`panel-modal-alertMessage-${dataPanel}`}>{message}</p>
      {children}
    </Container>
  );
};

Alert.propTypes = {
  message: PropTypes.string.isRequired
};

export default Alert;

const Container = styled.div`
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent};
  align-items: ${({ alignContent }) => alignContent};
  gap: 8px;
  border-radius: 4px;
  min-height: ${({ minHeight }) => minHeight};
  width: 100%;
  border: 1px solid ${({ withoutBorder }) => select(withoutBorder ? 'transparent' : 'midLightGray')};
  border-left: 3px solid ${select('darkGray')};
  padding: ${({ padding }) => padding};
  margin: ${({ margins }) => margins};
  > span {
    height: 18px;
    min-width: 18px;
    background-image: ${`url(${alertCircleIcon})`};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin-right: ${({ marginRightIcon }) => marginRightIcon};
    display: block;
    position: relative;
    top: 2px;
  }
  > p {
    font-family: Hind;
    font-size: ${({ fontSize }) => fontSize};
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
    white-space: break-spaces;
  }
  ${({ colorScheme }) => {
    if (colorScheme === 'blue') {
      return css`
        border-left-color: ${select('blue')};
        background-color: ${select('lightGray')};
        > span {
          background-image: ${`url(${blueAlertCircleIcon})`};
        }
      `;
    }
  }}
`;
